/**
 * Datas do sistema chegam como TEXTO do Postgres ('YYYY-MM-DD' ou
 * 'YYYY-MM-DD HH24:MI:SS').
 *
 * Nada aqui passa por `new Date(texto)`: a string sem hora e interpretada como
 * UTC pelo JavaScript, entao '2026-08-25' vira 24/08 em fuso negativo -- que e
 * o nosso. Todas as funcoes trabalham sobre as partes da string.
 */

const doisDigitos = (n: number) => String(n).padStart(2, '0');

/** '2026-08-25' -> '25/08/2026'. Entrada nao reconhecida volta como veio. */
export const dataPtBr = (valor: string | null): string => {
  if (!valor) return valor ?? '';

  const partes = /^(\d{4})-(\d{2})-(\d{2})/.exec(valor);
  return partes ? `${partes[3]}/${partes[2]}/${partes[1]}` : valor;
};

/** '2026-08-25 15:53:03' -> '25/08/2026 15:53'; sem valor -> 'nunca'. */
export const dataHoraPtBr = (valor: string | null): string => {
  if (!valor) return 'nunca';

  const partes = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/.exec(valor);
  if (!partes) return valor;

  const [, ano, mes, dia, hora, minuto] = partes;
  return `${dia}/${mes}/${ano} ${hora}:${minuto}`;
};

/** Data local de hoje em 'YYYY-MM-DD' (toISOString converteria para UTC). */
export const hojeLocal = (agora: Date = new Date()): string =>
  `${agora.getFullYear()}-${doisDigitos(agora.getMonth() + 1)}-${doisDigitos(
    agora.getDate()
  )}`;

/** Dias de CALENDARIO entre duas datas em texto; a hora nao influencia. */
export const diasEntre = (ate: string, de: string): number => {
  const emDias = (valor: string) => {
    const [ano, mes, dia] = valor.slice(0, 10).split('-').map(Number);
    return Date.UTC(ano, mes - 1, dia) / 86400000;
  };

  return emDias(ate) - emDias(de);
};
